/* Sipsy: Rez Preorder buttons on product cards (Oct 9 2026).
   Problem 1: with a quantity stepper on the card, Rez clicked the FIRST card's hidden Add to Cart button, so Preorder on one product added another (Humano Texas Edition).
   Fix: use Rez's supported hook window.rezSupportUseDirectCartAdd so a card's Preorder button adds that card's own variant directly, and copy the card's stepper quantity into the request (Rez's direct path ignores it).
   Problem 2: Rez's direct add never refreshes the cart drawer or icon, so the drawer (and its 'Complete the bundle' upsell) stayed stale/empty after adding a preorder. After a successful card add the drawer + icon are now refreshed and the drawer opens, like a normal Add to Cart.
   Scope: only clicks on .rez-preorder-collection-btn inside .card-wrapper. Product page Preorder is untouched. */
(function () {
  'use strict';
  if (window.__sipsyRezCardFix) return;
  window.__sipsyRezCardFix = true;
  var last = null;
  var WINDOW_MS = 5000;
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.rez-preorder-collection-btn');
    var card = btn && btn.closest('.card-wrapper');
    if (!card) return;
    var form = card.querySelector('form[action*="/cart/add"]');
    var idEl = form && form.querySelector('[name="id"]');
    var qEl = form && form.querySelector('input[name="quantity"]');
    last = { variantId: idEl ? String(idEl.value) : null, qty: Math.max(1, parseInt(qEl && qEl.value, 10) || 1), at: Date.now() };
  }, true);
  function fresh() { return !!last && Date.now() - last.at < WINDOW_MS; }
  window.rezSupportUseDirectCartAdd = function () { return fresh(); };

  var origFetch = window.fetch;

  function refreshCartUi() {
    Promise.all([
      origFetch('/cart?section_id=cart-drawer').then(function (r) { return r.text(); }),
      origFetch('/cart?section_id=cart-icon-bubble').then(function (r) { return r.text(); })
    ]).then(function (res) {
      var parser = new DOMParser();
      var drawer = document.querySelector('cart-drawer');
      var cd = document.getElementById('CartDrawer');
      var nd = parser.parseFromString(res[0], 'text/html').querySelector('#CartDrawer');
      if (cd && nd) cd.innerHTML = nd.innerHTML;
      var nb = parser.parseFromString(res[1], 'text/html').querySelector('#cart-icon-bubble');
      var ob = document.getElementById('cart-icon-bubble');
      if (nb && ob) ob.innerHTML = nb.innerHTML;
      if (drawer) {
        drawer.classList.remove('is-empty');
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
        if (drawer.open) drawer.open();
      }
    }).catch(function () { /* the item is already in the cart; a stale drawer is not fatal */ });
  }

  window.fetch = function (resource, init) {
    var isCardAdd = false;
    try {
      var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      if (fresh() && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
        var body = JSON.parse(init.body);
        var item = body && body.items && body.items[0];
        if (item && String(item.id) === last.variantId) {
          isCardAdd = true;
          if (last.qty > 1) {
            item.quantity = last.qty;
            init = Object.assign({}, init, { body: JSON.stringify(body) });
          }
        }
      }
    } catch (err) { /* never block an add to cart */ }
    var p = origFetch.call(this, resource, init);
    if (isCardAdd) {
      p.then(function (r) { if (r && r.ok) refreshCartUi(); }).catch(function () {});
    }
    return p;
  };
})();
